// TODO: Replace usage with components/ui/ContentContainer
import { styled, Grid } from "@material-ui/core"

export const ContentContainer = styled(Grid)(({ theme }) => ({
  borderRadius: 8,
  background: "#24282D"
}))
